const LANGUAGES = {
  en: {
    momentLocale: 'en-gb',
  },
  fr: {
    momentLocale: 'fr',
  },
  de: {
    momentLocale: 'de',
  },
  es: {
    momentLocale: 'es',
  },
  it: {
    momentLocale: 'it',
  },
  nl: {
    momentLocale: 'nl',
  },
  pt: {
    momentLocale: 'pt',
  },
  zh: {
    momentLocale: 'zh-cn',
  },
};

export default LANGUAGES;
